import FormHandler, { GoogleV2 } from '../grit-form-handler';
import { msg } from '../main';

export const INIT_contractor = () => {
  const gRecaptchaSiteKey = document
    .querySelector("meta[name='google_recaptcha_site_key']")
    .getAttribute('content');

  // Filters
  const contractorFilterForm = document.getElementById(
    'form_contractor-portal-filters'
  );

  if (contractorFilterForm) {
    const contractorFilters = contractorFilterForm.querySelectorAll(
      '.portal--filter select'
    );

    if (typeof contractorFilters != 'undefined' && contractorFilters != null) {
      contractorFilters.forEach(filter => {
        filter.addEventListener('change', () => {
          // contractorFilterForm.submit();
        });
      });
    }
  }

  // Delivery details
  const deliveryDetailsForms = [
    ...document.querySelectorAll(
      'form[name=contractor-portal-order-details], form[name=contractor-portal-assign-team], form[name=contractor-portal-create-team], form[name=contractor-portal-update-team], form[name=contractor-portal-delete-team], form[name=contractor-portal-change-seen]'
    ),
  ];

  if (deliveryDetailsForms) {
    deliveryDetailsForms.forEach(form => {
      const dataAlerts = form.dataset.formAlerts;

      form.addEventListener('submit', () => {
        document.body.classList.add('is-loading');
      });

      new FormHandler(`#${form.id}`, {
        recaptcha: false,
        flashMessage: msg,
        resetOnSuccess: false,
        localisation: {
          success: dataAlerts.success
            ? dataAlerts.success
            : 'Thank you for your submission.',
          error: dataAlerts.error
            ? dataAlerts.error
            : 'There was an error with your submission.',
        },
        scrollToError: {
          enabled: true,
          offset: 0,
        },
        validate: {
          onChange: true,
          onSubmit: true,
        },
        onSuccess: (form, res) => {
          // Contractor portal order details
          if (
            form.name === 'contractor-portal-order-details' ||
            form.name === 'contractor-portal-assign-team'
          ) {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.success, true);

            document.body.classList.remove('is-loading');

            document
              .querySelectorAll(
                `#${form.id} input, #${form.id} select, #${form.id} button`
              )
              .forEach(el => {
                el.disabled = true;
              });
          }

          // Manage Team Forms
          if (
            form.name === 'contractor-portal-create-team' ||
            form.name === 'contractor-portal-update-team' ||
            form.name === 'contractor-portal-delete-team'
          ) {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.success, true);

            document.body.classList.remove('is-loading');

            setTimeout(() => {
              location.reload();
            }, 300);
          }

          if (form.name === 'contractor-portal-change-seen') {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.success, true);

            const historyItems = form
              .closest('.order-history')
              .querySelectorAll('.history-item');

            historyItems.forEach(historyItem => {
              if (historyItem.classList.contains('not-seen')) {
                historyItem.classList.remove('not-seen');
              }
            });

            const orderId = form.dataset.orderId;
            const total = document.querySelector(
              `.order--history--icon--total[data-order-id="${orderId}"]`
            );

            if (total !== null || total !== undefined) {
              total.closest('.order--history--icon').classList.add('hide-all');
            }

            form.querySelector('.mark-as-seen').disabled = true;

            document.body.classList.remove('is-loading');
          }
        },
        onError: (form, res) => {
          // Contractor portal order details
          if (
            form.name === 'contractor-portal-order-details' ||
            form.name === 'contractor-portal-assign-team' ||
            form.name === 'contractor-portal-create-team' ||
            form.name === 'contractor-portal-update-team' ||
            form.name === 'contractor-portal-delete-team' ||
            form.name === 'contractor-portal-change-seen'
          ) {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.error, false);

            document.body.classList.remove('is-loading');

            // setTimeout(() => {
            //   location.reload();
            // }, 300);
          }
        },
      });

      // form.querySelectorAll('input').forEach(input => {
      //   input.addEventListener('change', () => {
      //     formInstance.submit();
      //   });
      // });
    });
  }
};

// Set history totals
const orderHistory = document.querySelectorAll('.order-history');

orderHistory.forEach(history => {
  setHistoryUnreadTotal(history);
});

function setHistoryUnreadTotal(history) {
  const notSeenTotal = history.querySelectorAll('.not-seen').length;
  const orderId = history.dataset.orderId;
  const total = document.querySelector(
    `.order--history--icon--total[data-order-id="${orderId}"]`
  );

  if (total != null && total != undefined) {
    total.innerHTML = notSeenTotal;

    if (notSeenTotal !== 0) {
      total.closest('.order--history--icon').classList.remove('hide-all');
      history.querySelector('.mark-as-seen').disabled = false;
    }
  }
}

if (document.querySelectorAll('.not-seen').length > 0) {
  const popupSeen = document.querySelector('#modal-order_changes');
  if (!popupSeen.classList.contains('contractor_popup_seen')) {
    MicroModal.show('modal-order_changes');
  }
}
